import { ActionSchema } from ".";
import { AnalyticsProperties } from "../../services/analytics/types";

export const AnalyticsConst = {
  SET_USER_PROPERTIES: "ANALYTICS_SET_USER_PROPERTIES",
  RESET: "ANALYTICS_RESET"
};

let analyticsEventId = 0;

export interface AnalyticsUserPropertiesSchema {
  id: number;
  properties: AnalyticsProperties;
}

export const setAnalyticsUserPropertiesAction = (properties: AnalyticsProperties = {}) => {
  const payload: AnalyticsUserPropertiesSchema = {
    id: ++analyticsEventId,
    properties
  };

  return {
    type: AnalyticsConst.SET_USER_PROPERTIES,
    payload
  };
};

export const resetAnalyticsAction = () => {
  return {
    type: AnalyticsConst.RESET,
    payload: { id: ++analyticsEventId }
  };
};

export type AnalyticsActionSchema = ActionSchema<AnalyticsUserPropertiesSchema | { id: number }>;
